import Vue from "vue";
import ScrollLock from "../../components/rest-menu-components/utilities/scroll-lock";
var axios = require("axios");
var Sentry = require("@sentry/vue");

const state = {
  restListLarge: {},
  restListHeader: {},
  filterableRestList: [],
  orthogonalRestLists: [],
  customerCart: {},
  showCart: false,
  cartIsLoading: false,
  currentEditItem: {},
  isCurrentEditItemLoaded: false,
  editItemOpen: false,
  toastedMessage: ""
};

export const actions = {
  setInitRestListState({ commit, dispatch }) {
		if (window.restListLargeData) {
      var restListLargeData = window.restListLargeData;
      commit("setRestListLargeData", restListLargeData);
      dispatch("filterRestList", "");
      commit("setCategoryFilterList");
		} else {
      Sentry.captureException(
				new Error("Rest List: Initial rest list state failed to load.")
      );
			return;
		}
  },
  setInitRestListHeaderState({ commit }) {
		if (window.restListHeaderData) {
      var restListHeaderData = window.restListHeaderData;
      commit("setRestListHeaderData", restListHeaderData);
		} else {
      Sentry.captureException(
				new Error("Rest List Header: Initial rest list header state failed to load.")
      );
			return;
		}
  },
  setInitCustomerCartState({ commit }) {
    if (window.cartData) {
      var customerCartData = window.cartData;
      commit("setCustomerCartData", customerCartData);
		} else {
      Sentry.captureException(
				new Error("Rest List: Initial customer cart state failed to load.")
      );
			return;
		}
  },
  setInitOrthogonalRestLists({ commit }) {
    if (window.orthogonalRestLists) {
      var orthogonalRestLists = window.orthogonalRestLists;
      commit("setOrthogonalRestLists", orthogonalRestLists);
		}
  },
  getCustomerCartData({ commit }) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append("mode", 'getCustomerCart');
    axios.defaults.headers['Pragma'] = 'no-cache'; // prevents IE11 from caching the get request
    return axios
      .get("/chooseRestaurant.pl?" + params)
      .then(response => {
        if (response.data.success) {
          commit("setCustomerCartData", response.data.success);
          commit("setCartIsLoading", false);
          return true;
        } else {
          Sentry.captureException(new Error("Rest List Cart: Request to get customer cart data failed."));
          commit("setCartIsLoading", false);
          return false;
        }
      })
    .catch(function (error) {
      Sentry.captureException(
        new Error('Rest List Cart Network Error: request for "checktime" Failed')
      );
      commit("setCartIsLoading", false);
      return false;
    })
  },
  getItemOptions({ commit }, payload) {
    var params = new URLSearchParams();
    params.append("mode", 'getOptions');
    params.append("itemId", payload.itemId);
    return axios
      .post("/yourOrder.pl?", params)
      .then(response => {
        if (response.data) {
          return response.data;
        }
      })
    .catch(function (error) {
      Sentry.captureException(
        new Error('Rest List Cart Network Error: request for getOptions Failed')
      );
      return false;
    })
  },
  getOptionDetails({ commit }, payload) {
    var params = new URLSearchParams();
    params.append("mode", 'optDetails');
    params.append("itemId", payload.itemId);
    return axios
      .post("/yourOrder.pl?", params)
      .then(response => {
        if (response.data.success) {
          return response.data.success;
        } else {
          Sentry.captureException(new Error("Rest List Cart: Request for optDetails failed."));
          return false;
        }
        
      })
    .catch(function (error) {
      Sentry.captureException(
        new Error('Rest List Cart Network Error: request for optDetails Failed')
      );
      return false;
    })
  },
  filterRestList({ commit }, payload) {
    commit("filterRestListLargeData", payload);
  },
  filterByTag({ commit, dispatch }, tag) {
    if (!tag.length) {
      dispatch("filterRestList", "");
      commit("setTitleFilter", "");
      return false;
    }
    commit("filterRestListByTag", tag);
    commit("setTitleFilter", tag);
  },
  checkTime({ commit }, payload) {
    var params = new URLSearchParams();
    params.append("mode", "checktime");
    params.append("duedate", payload.duedate);
    params.append("hour", payload.dueHour);
    params.append("minute", payload.dueMin);
    params.append("restId", payload.restId);
    return axios
      .post("/later-order.pl?", params)
      .then(response => {
        if (response.data.errors) {
          var errorMsg = "";
          for (var eachError in response.data.errors) {
            errorMsg += '\n' + response.data.errors[eachError]  + '\n';
          }
          alert(errorMsg);
          Sentry.addBreadcrumb({
            category: "exception",
            message: errorMsg,
            level: Sentry.Severity.error
          });
          Sentry.captureException(
            new Error('user entered an invalid "later date/time"')
          );
          return false;
        }
        if (response.data.success) {
          return true;
        }
      })
      .catch(function (error) {
        Sentry.captureException(
          new Error('Rest List Network Error: request for "checktime" Failed')
        );
        return false;
      })
  },
  setTime({ commit }, payload) {
    var params = new URLSearchParams();
    params.append("mode", "set");
    params.append("duedate", payload.duedate);
    params.append("hour", payload.dueHour);
    params.append("minute", payload.dueMin);
    return axios
      .post("/later-order.pl?", params)
      .then(function () {
        return true;
      })
      .catch(function (error) {
        Sentry.captureException(
          new Error('Rest List Network Error: request for "setTime" Failed')
        );
        return false;
      })
  },
  goToNewRestList({ commit, state }, payload) {
    var params = new URLSearchParams();
    params.append("mode", "whichzone");
    params.append('lat', payload.lat);
    params.append('lng', payload.lng);
    
    return axios
      .post("/selectZone.pl?", params)
      .then(response => {
        if (response.data.errors) {
          // OutOfArea should be the error returned
          alert(payload.address + " appears to be outside of our delivery area. \nHowever, we may still be able to take your order. \nPlease call the office at " + state.restListHeader.locationHero.businessPhone + " and we will \ntry our best to accomodate you.");
          return false;
        } else if (response.data.success) {
          if (response.data.success.blocked) {
            alert('Sorry! ' + response.data.success.blocked + '\n' + response.data.success.reason);
            return false;
          }
          window.location.href = '/'+response.data.success.URLCity+'/restaurants/delivery';
          return true;
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest List Network Error: request whichzone failed'));
        return false;
      })
  },
  async editItem({ commit, dispatch }, payload) {
    dispatch("openCloseEditItemModal", true);
    await dispatch('getCurrentItemEdit',{
      itemId: payload.itemId, restId: payload.restId
    });
  },
  removeItem({ commit }, payload) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append('mode', 'removeItem');
    params.append('itemId', payload.itemId);
    params.append('restId', payload.restId);
    
    return axios
      .post("/chooseRestaurant.pl?", params)
      .then(response => {
        if (response.data.success) {
          commit("setCustomerCartData", response.data.success);
          commit("setCartIsLoading", false);
          return true;
        } else {
          Sentry.addBreadcrumb({
            category: "exception",
            message: 'failed to remove itemId: ' + payload.itemId,
            level: Sentry.Severity.error
          });
          Sentry.captureException(
            new Error('failed to remove item from cart')
          );
          commit("setCartIsLoading", false);
          return false;
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest List Cart Network Error: request removeItem failed'));
        commit("setCartIsLoading", false);
        return false;
      })
  },
  addItemToCart({ dispatch, commit, state }, payload) {
    var params = new URLSearchParams();
    params.append("mode", "ajaxAdd");
    params.append("itemId",payload.itemId);
    params.append("markup",payload.markup);
    params.append("qty",payload.qty);
    params.append("optns",payload.options);
    params.append("whofor",payload.whofor);
    params.append("comments",payload.specInstructions);

    return axios
      .post("/yourOrder.pl", params)
      .then(response => {
        if (response.data.success) {
          if (payload.getCartData) {
            dispatch("getCustomerCartData");  
          } else {
            var dollarsign = '$ ';
            var subtotal = response.data.sucess.subtotal;
            var total = response.data.sucess.total;
            if (!parseFloat(subtotal)) {
              document.getElementById('nav_order_total').innerHTML = '';
            } else if (state.customerCartData.showStaffCartInfo){
                if (parseFloat(total) >= 10) {
                  dollarsign = '$';
                }
              document.getElementById('nav_order_total').innerHTML = dollarsign + total;
            } else {
              if (parseFloat(subtotal) >= 10) {
                dollarsign = '$';
              }
              document.getElementById('nav_order_total').innerHTML = dollarsign + subtotal;
            }
          }
          return true;
        } else {
          commit("setToastedMessage", "Failed to add item to cart.");
          dispatch("showToasted");
          return false;
        }
      })
      .catch(function (error) {
        console.log(error);
        commit("setToastedMessage", "Network request failed.");
        dispatch("showToasted");
        Sentry.captureException(new Error("Rest Menu Error: addItem request failed"));
        return false;
      });
  },
  editItemQty({ commit, dispatch }, payload) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append('mode', 'editItemQty');
    params.append('qty', payload.qty);
    params.append('itemId', payload.itemId);
    params.append('optns', payload.options);
    params.append('restId', payload.restId);
    if (payload.whofor) {
      params.append('whofor', payload.whofor);
    }
    if (payload.comment) {
      params.append('comments', payload.comment);
    }

    return axios
      .post("/chooseRestaurant.pl?", params)
      .then(response => {
        if (response.data.success) {
          commit("setCustomerCartData", response.data.success);
          commit("setCartIsLoading", false);
          return true;
        } else {
          Sentry.addBreadcrumb({
            category: "exception",
            message: 'failed to edit item qty: ' + payload.qty + ' for itemId: ' + payload.itemId,
            level: Sentry.Severity.error
          });
          Sentry.captureException(
            new Error('failed to edit qty for item in cart')
          );
          commit("setCartIsLoading", false);
          return false;
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest List Cart Network Error: request editItemQty failed'));
        commit("setCartIsLoading", false);
        return false;
      })
  },
  applyCoupon({ commit }, payload) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append("mode", "apply");
    params.append("couponcode", payload.couponCode);
    return axios
      .post("/applyCoupon.pl", params)
      .then(response => {
        if (response.data.errors) {
          var errorMsg =
            "We're sorry, we are unable to apply your coupon for the following reason:\n";

          for (var eachError in response.data.errors) {
            errorMsg += '\n - ' + response.data.errors[eachError] + '\n';
          }
          Sentry.addBreadcrumb({
            category: "exception",
            message: errorMsg,
            level: Sentry.Severity.error
          });
          Sentry.captureException(
            new Error('Rest List Cart: apply coupon error')
          );
          commit("setCartIsLoading", false);
          alert(errorMsg);
          return false;
        } else {
          commit("setTotal", response.data.success.total);
          commit("setCoupon", { response: response.data.success, couponName: payload.couponCode });
          if (response.data.success.overrideMin) {
            commit("setOverrideMin", true);
            commit("setMinimumStatus", 3);
            commit("setDifference", "");
            commit("setCustIsPayingMinFee", false);
          }
          commit("setCartIsLoading", false);
          return true;
        }
      })
      .catch(error => {
        Sentry.captureException(
          new Error('Rest List Cart Network Error: request to applyCoupon Failed')
        );
        commit("setCartIsLoading", false);
        return false;
    })
  },
  removeCoupon({ commit }, payload) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append("mode", "remove");
    return axios
      .post("/applyCoupon.pl", params)
      .then(response => {
        if (response.data.success) {
          commit("setTotal", response.data.success.total);
          commit("setCoupon", { response: response.data.success });
          commit("setCartIsLoading", false);
          return true;
        }
      })
      .catch(error => {
        Sentry.captureException(
          new Error('Rest List Cart Network Error: request to removeCoupon Failed')
        );
        commit("setCartIsLoading", false);
        return false;
      })
  },
  setTip({ commit }, payload) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append("mode", payload.mode); // mode is either 'custom' or 'perc'
    if (payload.mode === 'custom') {
      params.append("tipCustom", payload.tipAmt);
    } else {
      params.append("tipPerc", payload.tipPerc);
    }
    return axios
      .post("/setTip.pl", params)
      .then(response => {
        if (response.data.tipAmt) {
          commit("setTotal", response.data.total);
          commit("setTip", response.data.tipAmt);
          commit("setTipPercent", response.data.tipPerc);
          commit("setCartIsLoading", false);
          return response.data;
        } else if (response.data.errors) {
          if (response.data.minGrat) {
            commit("setTotal", response.data.total);
            commit("setTip", response.data.success.tip);
            commit("setTipPercent", response.data.success.tipPerc);
            commit("setCartIsLoading", false);
          }
          var errorMsg = "";
          for (var eachError in response.data.errors) {
            errorMsg += "\n" + response.data.errors[eachError] + "\n";
          }
          commit("setCartIsLoading", false);
          alert(errorMsg);
          return response.data;
        }
      })
      .catch(error => {
        Sentry.captureException(
          new Error('Rest List Network Error: request to setTip Failed')
        );
        commit("setCartIsLoading", false);
        return false;
    })
  },
   restComment({ commit }, payload) {
    var params = new URLSearchParams();
    params.append('mode', 'restComment');
    params.append('restId', payload.restId);
    params.append('comment', payload.comment);
    return axios
      .post('/yourOrder.pl', params)
      .then(response => {
        if (response.data.errors) {
          var errorMsg =
            "We're sorry, we are unable to change your comment for the following reason:\n";
          for (var eachError in response.data.errors) {
            errorMsg += '\n - ' + response.data.errors[eachError] + '\n';
          }
          Sentry.addBreadcrumb({
            category: "exception",
            message: errorMsg,
            level: Sentry.Severity.error
          });
          Sentry.captureException(
            new Error('Rest List Cart: rest comment error')
          );
          alert(errorMsg);
          return false;
        } else {
          commit('setRestComment', payload);
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest List Cart Network Error: request restComment Failed'));
        return false;
      })
  },
  sendBackToQueue({ commit }, payload) {
    var params = new URLSearchParams();
    params.append('mode', 'approve');
    params.append('cartid', payload.cartId)
    return axios
      .post('/yourOrder.pl', params)
      .then(response => {
        window.location.href = "/orderqueue.pl";
        return true;
    })
  },
  payMinFee({ commit }, payload) {
    var params = new URLSearchParams();
    params.append('mode', 'payMinFee');
    if (payload.remove === 'dontpay') {
      params.append('remove', payload.remove);
    }
    if (payload.cartId) {
      params.append('cartid', payload.cartId);
    }
    return axios
      .post('/chooseRestaurant.pl', params)
      .then(response => {
        if (response.data.success) {
          commit("setCustomerCartData", response.data.success);
          return true;
        }
      })
    .catch(function (error) {
      Sentry.captureException(new Error('Rest List Cart Network Error: request payMinFee Failed'));
      return false;
    })
  },
  clearOrder({ commit }, restID) {
    commit("setCartIsLoading", true);
    var params = new URLSearchParams();
    params.append('mode', 'clearOrder');
    params.append('restId', restID);

    return axios
      .post('/chooseRestaurant.pl', params)
      .then(response => {
        if (response.data.success) {
          commit("setCustomerCartData", response.data.success);
          commit("setCartIsLoading", false);
          return true;
        }
      })
    .catch(function (error) {
      Sentry.captureException(new Error('Rest List Cart Network Error: request clearOrder Failed'));
      commit("setCartIsLoading", false);
      return false;
    })
  },
  getCurrentItemEdit({ dispatch, commit }, payload) {
  var params = new URLSearchParams();
  params.append("mode", "getCurrentItemEdit");
  params.append("restId", payload.restId);
  params.append("itemId", payload.itemId);
  return axios
    .get("/chooseRestaurant.pl?" + params)
    .then(response => {
      if (response.data) {
        commit("setCurrentEditItem", response.data);
      } else {
        commit("setToastedMessage", "Could not get edit item options.");
        dispatch("showToasted");
      }
    })
    .catch(function (error) {
      console.log(error);
      commit("setToastedMessage", "Network request failed.");
      dispatch("showToasted");
      Sentry.captureException(new Error("Rest List Error: getCurrentItemEdit request failed"));
    })
    .then(() => {
      commit("setIsCurrentEditItemLoaded", true);
    });
  },
  openCloseEditItemModal({ commit }, isOpen) {
    commit("setEditItemOpen", isOpen);
    if (!isOpen) {
      commit("setCurrentEditItem", {});
    }
  },
  updateShowCart({ commit }, isOpen) {
    commit("setShowCart", isOpen);
  },
  updateCartIsLoading({ commit }, isLoading) {
    commit("setCartIsLoading", isLoading);
  },
  updateCurrentEditItemLoaded({ commit }, isLoaded) {
    commit("setIsCurrentEditItemLoaded", isLoaded);
  },
  showToasted({ commit, state }, payload) {
    Vue.toasted.show(state.toastedMessage, {
      action: {
        text: "DISMISS",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    });
  }
};

export const mutations = {
  setRestListLargeData(state, restListLargeData) {
    var restListLarge = restListLargeData;
    var cards = restListLarge.cards;
    var sortedList = cards.sort(
      function (cardX, cardY) {
        return (cardX.open === cardY.open) ? 0 : cardX.open ? -1 : 1;
      });
    restListLarge.cards = sortedList;
    Vue.set(state, "restListLarge", restListLarge);
  },
  filterRestListLargeData(state, searchQuery) {
    var cards = state.restListLarge.cards;
    var filteredRestList = cards.filter(card => {
      if (card.name.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1 || card.categories.find(category => category.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1)) {
        return true;
      } else {
        return false;
      }
    });

    Vue.set(state, "filterableRestList", filteredRestList);
  },
  setCategoryFilterList(state) {
    var acceptedTags = state.restListLarge.acceptedTags;
    var restTags = state.restListLarge.tagList;
    var tagList = restTags.filter(tag => {
      if (acceptedTags.find(acceptedTag => acceptedTag.indexOf(tag) > -1)) {
        return true;
      } else {
        return false;
      }
    });
    Vue.set(state.restListLarge, 'tagList', tagList);
  },
  filterRestListByTag(state, tag) {
    var cards = state.restListLarge.cards;
    var filteredRestList = cards.filter(card => {
      if (card.categories.find(category => category.indexOf(tag) > -1)) {
        return true;
      } else {
        return false;
      }
    })
    if (!filteredRestList.length) {
      Sentry.addBreadcrumb({
        category: "exception",
        message: tag,
        level: Sentry.Severity.error
      });
      Sentry.captureException(new Error('Rest List Error: Category Filter selected does not match any tag in rest list.'));
    }
    Vue.set(state, "filterableRestList", filteredRestList);
  },
  setTitleFilter(state, tag) {
    Vue.set(state.restListLarge, "titleFilter", tag);
  },
  setRestListHeaderData(state, restListHeaderData) {
    Vue.set(state, "restListHeader", restListHeaderData);
  },
  setCustomerCartData(state, customerCartData) {
    Vue.set(state, "customerCart", customerCartData);
    var dollarsign = '$ ';
    var subtotal = customerCartData.subtotal;
    var total = customerCartData.total;
    if (!parseFloat(subtotal)) {
      document.getElementById('nav_order_total').innerHTML = '';
    } else if (customerCartData.showStaffCartInfo){
        if (parseFloat(total) >= 10) {
          dollarsign = '$';
        }
      document.getElementById('nav_order_total').innerHTML = dollarsign + total;
    } else {
      if (parseFloat(subtotal) >= 10) {
        dollarsign = '$';
      }
      document.getElementById('nav_order_total').innerHTML = dollarsign + subtotal;
    }
  },
  setTotal(state, payload) {
    Vue.set(state.customerCart, "total", payload);
    var dollarsign = '$ ';
    if (parseFloat(payload) >= 10) {
      dollarsign = '$';
    }
    document.getElementById('nav_order_total').innerHTML = dollarsign + payload;
  },
  setTip(state, payload) {
    Vue.set(state.customerCart, "gratuityAmount", payload);
  },
  setTipPercent(state, payload) {
    Vue.set(state.customerCart, "gratuityPercent", payload);
  },
  setCoupon(state, payload) {
    if (payload.response.coupon) {
      Vue.set(state.customerCart, "couponAdj", payload.response.coupon);
      Vue.set(state.customerCart, "couponName", payload.couponName);
    } else {
      Vue.set(state.customerCart, "couponAdj", " 0.00");
      Vue.set(state.customerCart, "couponName", "");
    }
  },
  setRestComment(state, payload) {
    state.customerCart.orders.forEach(rest => {
      if (rest.id === payload.restId) {
        Vue.set(rest, 'specialInstructions', payload.comment);
      }
    })
  },
  setOverrideMin(state, payload) {
    Vue.set(state.customerCart, "minMetOrOverridden", payload);
  },
  setMinimumStatus(state, payload) {
    Vue.set(state.customerCart, "minimumStatus", payload);
  },
  setDifference(state, payload) {
    Vue.set(state.customerCart, 'difference', payload);
  },
  setCustIsPayingMinFee(state, payload) {
    Vue.set(state.customerCart, 'custIsPayingMinFee', payload);
  },
  setOrthogonalRestLists(state, orthogonalRestLists) {
    var returnLists = [];
    orthogonalRestLists.forEach(restList => {
      if (restList.rests.length >= 2) {
        returnLists.push(restList);
      }
    })
    Vue.set(state, 'orthogonalRestLists', returnLists);
  },
  setToastedMessage(state, newMessage) {
		Vue.set(state, "toastedMessage", newMessage);
  },
  setCurrentEditItem(state, editItemData) {
    Vue.set(state, "currentEditItem", editItemData);
  },
  setEditItemOpen(state, isOpen) {
    if (isOpen) {
      ScrollLock.enable();
    } else {
      ScrollLock.disable();
    }
    Vue.set(state, "editItemOpen", isOpen);
  },
  setShowCart(state, isOpen) {
    if (isOpen) {
      ScrollLock.enable();
    } else {
      ScrollLock.disable();
    }
    Vue.set(state, "showCart", isOpen);
  },
  setCartIsLoading(state, isLoading) {
    Vue.set(state, "cartIsLoading", isLoading);
  },
  setIsCurrentEditItemLoaded(state, newVal) {
    Vue.set(state, "isCurrentEditItemLoaded", newVal);
  },
};

export const getters = {
  currentEditItemObj: state => {
    return state.currentEditItem;
  },
  isCurrentEditItemLoaded: state => {
    return state.isCurrentEditItemLoaded;
  },
  allowItemNotes: state => {
    if (state.currentEditItem.allowItemNotes) {
      return true;
    } else {
      return false;
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}